module.exports = __webpack_public_path__ + "assets/icons/ic_lock_open-e05d.svg";